const filterProductForPromoCodes = (value, onlyOptionCreate, companies = []) => {
  const {
    digitizeProducts = [],
    enhanceProducts = [],
    createProducts = [],
    shippingProducts = [],
    giftProducts = [],
  } = value;

  const digitize = digitizeProducts.map((item) => {
    const {
      id,
      displayName,
      options,
      parentId,
      name,
    } = item;
    const productOptions = options.map((option) => ({
      value: option.id,
      label: option.displayName,
      isPersonalize: false,
      isMatting: false,
      parentId: option.parentId,
      type: 'digitize',
    }));
    return {
      value: id,
      label: displayName,
      productOptions,
      isPersonalize: false,
      isMatting: false,
      parentId,
      name,
      type: 'digitize',
    };
  });

  const enhance = enhanceProducts.reduce((accum, item) => {
    const {
      id,
      displayName,
      parentId,
      options,
      name: nameProduct,
      productCollectionId,
    } = item;
    if (productCollectionId) {
      return accum;
    }
    const productOptions = options.reduce((acc, option) => {
      const { name, customInfo } = option;
      // Exclude easy_scan_ship_kit and enhance_prints
      if (name === 'easy_scan_ship_kit' || name === 'enhance_prints') {
        return acc;
      }

      // Parse customInfo to get company name
      let companyName = '';
      if (customInfo) {
        try {
          const parsedCustomInfo = JSON.parse(customInfo);
          const companyId = parsedCustomInfo?.company?.companyId;
          if (companyId) {
            const company = companies.find((c) => c.id === companyId);
            if (company) {
              companyName = ` (${company.displayName})`;
            }
          }
        } catch (e) {
          // Invalid JSON, ignore
        }
      }

      return [
        ...acc,
        {
          value: option.id,
          label: `${option.displayName}${companyName}`,
          isPersonalize: false,
          isMatting: false,
          parentId: option.parentId,
          type: 'enhance',
        },
      ];
    }, []);
    return [...accum, {
      value: id,
      label: displayName,
      productOptions,
      isPersonalize: false,
      isMatting: false,
      parentId,
      name: nameProduct,
      type: 'enhance',
    }];
  }, []);

  const create = createProducts.reduce((accum, item) => {
    const {
      id,
      displayName,
      options,
      parentId,
      name,
      productCollectionId,
      productCollectionName,
      frameMaterial,
      frameMaterialId,
    } = item;
    if (productCollectionId) {
      return accum;
    }
    const productOptions = options.reduce((acc, option) => {
      const {
        id: optionId,
        frameColor,
        frameOrientation,
        frameSize,
        isPersonalize,
      } = option;
      const personalize = isPersonalize ? 'personalize' : '';
      return [
        ...acc,
        ...(!onlyOptionCreate ? [{
          value: optionId,
          label: `${frameColor ? frameColor.name : ''} ${frameOrientation} ${frameSize.name} ${personalize}`,
          isPersonalize,
          isMatting: false,
          parentId: option.parentId,
          type: 'photo_art',
        },
        {
          value: optionId,
          label: `${frameColor ? frameColor.name : ''} ${frameOrientation} ${frameSize.name} ${personalize} matting`,
          isPersonalize,
          isMatting: true,
          parentId: option.parentId,
          type: 'photo_art',
        }] : [{
          value: optionId,
          label: `${frameColor ? frameColor.name : ''} ${frameOrientation} ${frameSize.name}`,
          type: 'photo_art',
        }]),
      ];
    }, []);

    return [...accum, {
      value: id,
      label: displayName,
      isPersonalize: item.isPersonalize,
      isMatting: false,
      productOptions,
      parentId,
      productCollectionId,
      productCollectionName,
      name,
      frameMaterial,
      frameMaterialId,
      type: 'photo_art',
    }];
  }, []);

  const shipping = shippingProducts ? shippingProducts.map((item) => {
    const {
      id,
      displayName,
      parentId,
      name,
    } = item;
    return {
      value: id,
      label: displayName,
      productOptions: null,
      isPersonalize: false,
      isMatting: false,
      parentId,
      name,
      type: 'shipping',
    };
  }) : [];

  const gifts = giftProducts
    ? giftProducts.map((item) => {
      const { id, displayName, parentId } = item;
      return {
        value: id,
        label: displayName,
        productOptions: null,
        isPersonalize: false,
        isMatting: false,
        parentId,
        type: 'gift_card',
      };
    })
    : [];
  const digitizeResult = [{
    value: 'digitize',
    label: 'Digitize products',
    isOptionDisabled: true,
  },
  ...digitize,
  ];
  const enhanceResult = [{
    value: 'enhance',
    label: 'Enhance products',
    isOptionDisabled: true,
  },
  ...enhance,
  ];
  const createResult = [
    {
      value: 'create',
      label: 'Create products',
      isOptionDisabled: false,
    },
    ...create,
  ];
  const shippingResult = [
    ...shippingProducts
      ? [{
        value: 'shipping',
        label: 'Shipping products',
        isOptionDisabled: true,
      },
      ...shipping]
      : {},
  ];
  const giftResult = [{
    value: 'gift_card',
    label: 'Gift products',
    isOptionDisabled: true,
  },
  ...gifts,
  ];
  const result = [
    ...digitizeResult,
    ...enhanceResult,
    ...createResult,
    ...shippingResult,
    ...giftResult,
  ];
  return result;
};

export default filterProductForPromoCodes;
